import {MC_Device} from "../common/iot/MC_Device";

// Class to define what devices can be created
export interface CustomDevice {
    rawType: string,
    fullTypeName: string,
    description: string
}
// Create device
export class CustomDeviceFactory {

    // Devices
    public static TYPE_TH: string = "TH";
    public static TYPE_CO2: string = "CO2";
    public static TYPE_STEFFES: string = "STEFFES";
    public static FULL_TYPE_TH: string = "Temperature/Humidity Sensor";
    public static FULL_TYPE_CO2: string = "CO2 Sensor";
    public static FULL_TYPE_STEFFES: string = "Steffes Prototype";

    public static SUPPORTED_DEVICES: CustomDevice[] = [
        {
            rawType: this.TYPE_TH,
            fullTypeName: this.FULL_TYPE_TH,
            description: ""
        },
        {
            rawType: this.TYPE_CO2,
            fullTypeName: this.FULL_TYPE_CO2,
            description: ""
        },
        {
            rawType: this.TYPE_STEFFES,
            fullTypeName: this.FULL_TYPE_STEFFES,
            description: ""
        }
    ];

    public static fromData(data: any): MC_Device {
        const type: string | null = (data[MC_Device.FIELD_TYPE] != null)
            ? data[MC_Device.FIELD_TYPE] as string
            : null
        ;
        if (type == null) {
            throw "Missing device type";
        }
        // Custom device types
        switch (type) {}
        // Return base device as default
        return new MC_Device(data);
    }

    public static getArrayFromData(dataArray: any[]): MC_Device[] {
        let devices: MC_Device[] = [];
        for (let i = 0; i < dataArray.length; i++) {
            try {
                devices = devices.concat(this.fromData(dataArray[i]));
            } catch (e) {
                console.error("Device parse err: " + e + ": " + JSON.stringify(dataArray[i]));
            }
        }
        return devices;
    }

    public static getFullDeviceType(type: string): string {
        switch (type) {
            case this.TYPE_TH: return this.FULL_TYPE_TH;
            case this.TYPE_CO2: return this.FULL_TYPE_CO2;
            case this.TYPE_STEFFES: return this.FULL_TYPE_STEFFES;
        }
        return "Unknown";
    }

}
